<template>
	<div>
		<div>
			<h2 class="ml-5">Status oceny komisji: {{getEvaluationStatus()}}</h2>
			<div v-if="committeeData.evaluationStatus === 'INDIVIDUAL_EVALUATION' && managementAccess">
				<v-btn class="mt-2 mb-2 ml-5" @click="startCommitteeEvaluation">Rozpocznij ocenianie komisji</v-btn>
			</div>
			<div v-if="committeeData.evaluationStatus === 'COMMITTEE_EVALUATION' && managementAccess">
				<v-btn class="mt-2 mb-2 ml-5" @click="finishCommitteeEvaluation">Zakończ ocenę komisji</v-btn>
			</div>
			<div v-if="committeeData.evaluationStatus === 'FINISHED' && managementAccess">
				<v-btn class="mt-2 mb-2 ml-5" @click="undoFinishCommitteeEvaluation">Cofnij</v-btn>
			</div>
			<egranty-error-list-popup
				title="Nie udało się rozpocząć oceny komisji"
				:error-list="startEvaluationErrors.messages"
				:is-open="startEvaluationErrors.showPopup"
				@close="startEvaluationErrors.showPopup = false"
			/>
			<egranty-error-list-popup
				title="Nie udało się zakończyć oceny komisji"
				:error-list="finishEvaluationErrors.messages"
				:is-open="finishEvaluationErrors.showPopup"
				@close="finishEvaluationErrors.showPopup = false"
			/>
			<egranty-error-list-popup
				title="Nie udało się cofnąć zakończenia oceny komisji"
				:error-list="undoFinishEvaluationErrors.messages"
				:is-open="undoFinishEvaluationErrors.showPopup"
				@close="undoFinishEvaluationErrors.showPopup = false"
			/>
		</div>
		<br/>
		<div v-for="error in errors" :key="error + 'up'">
			<egranty-validation-error
				:error="error"
			/>
		</div>
		<handy-scroll class="handscrolls" ref="handscrolls">
			<evaluation-summary-table
				class="contest-evaluation-summary-view-table"
				:table-name="viewTitle"
				:headers="evaluationsData.headers"
				:items="evaluationsData.items"
				:rating-settings="contestData.ratingSettings"
				:row-toolbar-actions-visible="false"
				:hide-pagination="false"
				:hideable-columns="true"
				:export-enabled="true"
				:disable-all-fields="['FINISHED', 'INDIVIDUAL_EVALUATION', 'BEFORE_EVALUATION'].includes(committeeData.evaluationStatus)"
				@item-updated="updateSummary"
				compact
			></evaluation-summary-table>
		</handy-scroll>
		<div v-for="error in errors" :key="error + 'down'">
			<egranty-validation-error
				:error="error"
			/>
		</div>
	</div>
</template>

<script>
	import {EvaluationSummary} from "@/api/generated/EvaluationSummary";
	import {Committee} from "@/api/generated/Committee";
	import {Numbers} from "@/utils/Numbers";
	import EvaluationSummaryTable from "./components/EvaluationSummaryTable";
	import EgrantyValidationError from "../../../genericComponents/EgrantyValidationError";
	import EgrantyErrorListPopup from "../../../genericComponents/EgrantyErrorListPopup";
	import HandyScroll, {EventBus} from "vue-handy-scroll";
	import {Api} from "@/api";

	export default {
		name: "ContestEvaluationSummaryView",

		components: {EgrantyErrorListPopup, EgrantyValidationError, EvaluationSummaryTable, HandyScroll},

		mixins: [Numbers],

		data() {
			return {
				errors: [],
				managementAccess: false,
				contestData: {
					id: this.$route.params.id,
					name: "",
					ratingSettings: {
						firstCommitteeCriteriaName: "Pierwsze kryterium",
						secondCommitteeCriteriaName: "Drugie kryterium",
						booleanEvaluation: false,
					},
				},
				startEvaluationErrors: {
					showPopup: false,
					messages: [],
				},
				finishEvaluationErrors: {
					showPopup: false,
					messages: [],
				},
				undoFinishEvaluationErrors: {
					showPopup: false,
					messages: [],
				},
				committeeData: {
					id: this.$route.params.committeeId,
					name: "",
				},
				evaluationsData: {
					items: [],
					headers: [],
				},
			};
		},

		watch: {
			evaluationsData() {
				EventBus.$emit("update");
			},
		},

		computed: {
			viewTitle() {
				return "Zbiorcza ocena ofert w komisji \"" + this.committeeData.name + "\"";
			},
		},

		created() {
			loadCommitteeData(this);
			loadData(this);
			loadManagementAccessStatus(this);
		},

		methods: {

			startCommitteeEvaluation() {
				Committee.postEvaluation(this, this.committeeData.id, () => {
					loadCommitteeData(this);
				}, error => {
					this.startEvaluationErrors.messages = error.message.split("\n");
					this.startEvaluationErrors.messages.pop();
					this.startEvaluationErrors.showPopup = true;
				});
			},

			finishCommitteeEvaluation() {
				Committee.putEvaluation(this, this.committeeData.id, () => {
						loadCommitteeData(this);
					},
					error => {
						this.finishEvaluationErrors.messages = error.message.split("\n");
						this.finishEvaluationErrors.showPopup = true;
					});
			},

			undoFinishCommitteeEvaluation() {
				Committee.putUndoFinishEvaluation(this, this.committeeData.id, () => {
						loadCommitteeData(this);
					},
					error => {
						this.undoFinishEvaluationErrors.messages = error.message.split("\n");
						this.undoFinishEvaluationErrors.showPopup = true;
					});
			},

			getEvaluationStatus() {
				let status = this.committeeData.evaluationStatus;

				if (status === "BEFORE_EVALUATION") {
					return "Przed ocenami indywidualnymi";
				}

				if (status === "INDIVIDUAL_EVALUATION") {
					return "Oceny indywidualne";
				}

				if (status === "COMMITTEE_EVALUATION") {
					return "Ocena komisji";
				}

				if (status === "FINISHED") {
					return "Ocena zakończona";
				}
			},

			reinitialize() {
				loadOffers(this, false);
			},

			updateSummary(summary) {
				this.errors = [];
				this.validateCriteria(summary);

				if (this.errors.length) return;
				if (!processDynamicValues(summary, this.evaluationsData.headers, this.errors)) return;

				EvaluationSummary.put(this, summary,
					success => {
						this.$messagesBus.$emit("success", "Zapisano zmiany", success);
						this.reinitialize();
					},
					error => {
						this.$messagesBus.$emit("error", "Nie udało się wprowadzić zmian", error);
					});
			},

			validateCriteria(offerSummary) {
				if (isSubstantiveEvaluationBinary(offerSummary)) return;
				let min1 = this.contestData.ratingSettings.firstCommitteeCriteriaMinPoints;
				let max1 = this.contestData.ratingSettings.firstCommitteeCriteriaMaxPoints;
				let min2 = this.contestData.ratingSettings.secondCommitteeCriteriaMinPoints;
				let max2 = this.contestData.ratingSettings.secondCommitteeCriteriaMaxPoints;
				let criterion1 = offerSummary.relevancy;
				let criterion2 = offerSummary.efficiency;
				let offerCode = offerSummary.offerCode;

				if (criterion1 !== null) {
					if (criterion1 < min1 || criterion1 > max1) {
						this.errors.push("Pierwsze kryterium oceny komisji w ofercie " + offerCode + "  musi być liczbą z zakresu  [" + min1 + "," + max1 + "]");
					}
				}

				if (criterion2 !== null) {
					if (criterion2 < min2 || criterion2 > max2) {
						this.errors.push("Drugie kryterium oceny komisji w ofercie " + offerCode + " musi być liczbą z zakresu  [" + min2 + "," + max2 + "]");
					}
				}
			},

			getAverage(values) {
				if (!values) return null;
				let count = values.length;
				if (count === 0) return 0;
				let sum = values.reduce((a, b) => a + b, 0);
				return sum / count;
			},
		},
	};

	function processDynamicValues(summary, headers, errors) {
		const endsWithNumber = new RegExp("(.*)(\\d+)");
		headers.forEach(header => {
			if (header.editable && endsWithNumber.test(header.value)) {
				const result = endsWithNumber.exec(header.value);
				if (moduleForHeaderExists(header.value, result[2], summary.moduleCount)) {
					if (isNaN(summary[header.value])) {
						errors.push("Wartość " + summary[header.value] + " powinna być liczbą.");
						return false;
					}
					summary[result[1]][result[2] - 1] = summary[header.value];
				}
			}
		});
		return true;
	}

	function moduleForHeaderExists(header, module, moduleCount) {
		return (header.includes("requestedDotations") || header.includes("ownContributions")
			|| header.includes("appliedDotations") || header.includes("dotationReductions"))
			&& module <= moduleCount;
	}

	function loadOffers(ctx, firstLoad) {
		let successHandler = (successResponse) => {
			ctx.evaluationsData.headers = processItemsAndBuildHeaders(ctx, successResponse);
			ctx.evaluationsData.items = successResponse;
			if (firstLoad) {
				EventBus.$emit("update");
			}
		};
		let errorHandler = (errorResponse) => {
			ctx.$messagesBus.$emit("error", "Nie udało się pobrać zbiorczej oceny", errorResponse);
		};

		EvaluationSummary.getCommittee(ctx, ctx.committeeData.id, successHandler, errorHandler);
	}

	function loadCommitteeData(ctx) {
		Committee.get(ctx, ctx.committeeData.id,
			(success) => {
				ctx.committeeData = success;
			}, (error) => {
				ctx.$messagesBus.$emit("error", "Nie udało się pobrać danych komisjii", error);
			});
	}

	function loadManagementAccessStatus (ctx) {
		Committee.getManagementAccessStatus(ctx, ctx.committeeData.id, successResponse => {
				ctx.managementAccess = successResponse;
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się pobrać uprawnień do zarządzania oceną komisji", errorResponse);
			});
	}

	async function loadData(ctx) {
		await loadContestData(ctx);
		loadOffers(ctx, true);
	}

	async function loadContestData(ctx) {
		await Api.syncGet(ctx, "/public-contest/evaluation-summary-view?contestId=" + ctx.contestData.id,
			success => {
				ctx.contestData = success;
			}, error => {
				ctx.$messagesBus.$emit ("error", "Nie udało się pobrać danych konkursu", error);
			});
	}

	function processItemsAndBuildHeaders(ctx, summaries) {
		let h = [];
		h.push(
			buildHeader("Lp.", "index", {s: false, f: false, t: "NUMBER", tooltip: "Liczba porządkowa"}),
			buildHeader("Nr oferty", "offerCode", {tooltip: "Numer oferty"}),
			buildHeader("Oferent", "mainBidderPolishName")
    );

    const mutualBiddersColumnCount = Math.max(...summaries.map(offer => offer.mutualBidders ? offer.mutualBidders.length : 0));
    for (let item of summaries) {
      appendMultiHeader(ctx, h, item, "Współoferent", "mutualBidders", {t: "TEXT", ic: " "}, mutualBiddersColumnCount);
    }

    h.push(
			buildHeader("Nazwa projektu", "title"),
			buildHeader("Kraj", "accreditationCountryName"),
			buildHeader("Mod.", "moduleCount", {t: "NUMBER", tooltip: "Liczba modułów"}),
			buildHeader("Wol.", "volunteerCount", {t: "NUMBER", tooltip: "Liczba wolontariuszy"}),
		);

    const requestedDotationsColumnCount = Math.max(...summaries.map(offer => offer.requestedDotations ? offer.requestedDotations.length : 0));
    const ownContributionsColumnCount = Math.max(...summaries.map(offer => offer.ownContributions ? offer.ownContributions.length : 0));
    for (let item of summaries) {
			appendMultiHeader(ctx, h, item, "Wnioskowana kwota", "requestedDotations", {
				t: "CURRENCY",
				ic: " M",
				su: true,
			}, requestedDotationsColumnCount);
			appendMultiHeader(ctx, h, item, "Wkład własny", "ownContributions", {t: "CURRENCY", ic: " M"}, ownContributionsColumnCount);
		}

		for (let item of summaries) {
			appendEvaluatorNameMultiHeader(ctx, h, item);
		}

    const formalEvaluationsColumnCount = Math.max(...summaries.map(offer => offer.formalEvaluations ? offer.formalEvaluations.length : 0));
		for (let item of summaries) {
			appendMultiHeader(ctx, h, item, "Opinia formalna", "formalEvaluations", {t: "BOOLEAN", ic: " "}, formalEvaluationsColumnCount);
		}

		for (let item of summaries) {
			if (isSubstantiveEvaluationBinary(item)) {
				appendEvaluatorValueMultiHeader(ctx, h, item, true);
			} else {
				appendEvaluatorValueMultiHeader(ctx, h, item, false);
			}
		}

		if (!ctx.contestData.ratingSettings.booleanEvaluation) {
			h.push(
          buildHeader("Średnia zbliżonych ocen", "averageSubstantiveEvaluationsPoints", {t: "NUMBER"}),
          buildHeader("Ocena współpracy", "collaborationEvaluation", {t: "NUMBER"})
      );
		}

		h.push(
			buildHeader("Opinia placówki", "agencyEvaluation", {t: "BOOLEAN"})
		);

		// Dodaj kolumny z nazwiskami ekspertów
    for (let item of summaries) {
			appendExpertNameMultiHeader(ctx, h, item);
		}

		// Dodaj kolumny z opiniami eksperckimi
    const expertEvaluationsColumnCount = Math.max(...summaries.map(offer => offer.expertEvaluations ? offer.expertEvaluations.length : 0));
    for (let item of summaries) {
			appendMultiHeader(ctx, h, item, "Opinia eksperta", "expertEvaluations", {t: "BOOLEAN", ic: " "}, expertEvaluationsColumnCount);
		}

		if (!ctx.contestData.ratingSettings.booleanEvaluation) {
			h.push(
          buildHeader("KOMISJA " + ctx.contestData.ratingSettings.firstCommitteeCriteriaName, "relevancy", {t: "NUMBER", e: true}),
          buildHeader("KOMISJA " + ctx.contestData.ratingSettings.secondCommitteeCriteriaName, "efficiency", {t: "NUMBER", e: true}),
          buildHeader("KOMISJA łącznie", "committeePointsSum", {t: "NUMBER"}),
          buildHeader("Ocena łączna", "finalPointsSum",
              {
                t: "NUMBER",
                pp: (i) => (parseFloat(i.committeePointsSum || 0))
                    + (parseFloat(i.averageSubstantiveEvaluationsPoints || 0))
                    + (parseFloat(i.collaborationEvaluation || 0))
                },
          ));
		}

		h.push(buildHeader("Rekomendacja komisji", "committeeDecision", {t: "COMMITTEE_DECISION", e: true}));

    const appliedDotationsColumnCount = Math.max(...summaries.map(offer => offer.appliedDotations ? offer.appliedDotations.length : 0));
    const dotationReductionsColumnCount = Math.max(...summaries.map(offer => offer.dotationReductions ? offer.dotationReductions.length : 0));
    for (let i = 0; i < summaries.length; i++) {
			let s = summaries[i];
			appendMultiHeader(ctx, h, s, "Rekomendowana kwota", "appliedDotations",
				{
					t: "CURRENCY",
					e: true,
					ic: " M",
					su: true,
					pp: (n) => (s) => {
						if (isNaN(s["appliedDotations" + n]) === true || s["appliedDotations" + n] === null || s["recommendedDotation" + n] === null) {
							return parseFloat(s["requestedDotations" + n]);
						}
						return parseFloat(s["appliedDotations" + n]);
					},
				}, appliedDotationsColumnCount);
			appendMultiHeader(ctx, h, s, "Redukcja", "dotationReductions",
				{
					t: "CURRENCY",
					ic: " M",
					su: true,
					pp: (n) => (s) => (parseFloat(s["requestedDotations" + n]) || 0) - (parseFloat(s["appliedDotations" + n]) || 0),
				}, dotationReductionsColumnCount);
		}

		h = sortAppliedDonationAndReductionColumns(h);
		return h;
	}

	function sortAppliedDonationAndReductionColumns(h) {
		let found = h.find(el => el.value === "appliedDotations1");
		if (!found) return;
		let index = h.indexOf(found);
		let sortablePart = h.splice(index, h.length - 1);
		sortablePart.sort((a, b) => {
			if (a.value.replace(/^\D+/g, '') > b.value.replace(/^\D+/g, '')) return 1;
			if (a.value.replace(/^\D+/g, '') < b.value.replace(/^\D+/g, '')) return -1;
			return a.value > b.value;
		});
		return h.concat(sortablePart);
	}

	function appendEvaluatorValueMultiHeader(ctx, headers, item, booleanEvaluation) {
		const rootKey = booleanEvaluation ? "substantiveEvaluationsRecommendings" : "substantiveEvaluationsPointSums";

		for (let j = 0; j < item.substantiveEvaluationDataList.length; j++) {
			let key = rootKey + (j + 1);

			let substantiveEvaluationDataValue = booleanEvaluation
				? item.substantiveEvaluationDataList[j].substantiveEvaluationRecommending
				: item.substantiveEvaluationDataList[j].substantiveEvaluationValue;
			ctx.$set(item, key, substantiveEvaluationDataValue);

			if (!headers.some(h => h.value === key)) {
				let text = "Ocena" + (item.substantiveEvaluationDataList.length > 1 ? " O" + (j + 1) : "");

				if (booleanEvaluation) {
					headers.push(buildHeader(text, key, {t: "BOOLEAN"}));
				}
				else {
					headers.push(buildHeader(text, key, {t: "NUMBER"}));
				}
			}
		}
	}

	function appendExpertNameMultiHeader(ctx, headers, item) {
		if (!item.expertNames) return;
		for (let j = 0; j < item.expertNames.length; j++) {
			let key = "expertNames" + (j + 1);

			ctx.$set(item, key, item.expertNames[j]);

			if (!headers.some(h => h.value === key)) {
				let text = "Ekspert" + (item.expertNames.length > 1 ? " " + (j + 1) + " (E" + (j + 1) + ")" : "");

				headers.push(buildHeader(text, key, {}));
			}
		}
	}

	function appendEvaluatorNameMultiHeader(ctx, headers, item) {
		for (let j = 0; j < item.substantiveEvaluationDataList.length; j++) {
			let key = "committeeNames" + (j + 1);

			ctx.$set(item, key, item.substantiveEvaluationDataList[j].evaluatorName);

			if (!headers.some(h => h.value === key)) {
				let text = "Opiniujący" + (item.substantiveEvaluationDataList.length > 1 ? " " + (j + 1) + " (O" + (j + 1) + ")" : "");

				headers.push(buildHeader(text, key, {}));
			}
		}
	}

	function appendMultiHeader(ctx, headers, item, rootText, rootKey, o = {}, columnCount) {
		const indexCaption = typeof o.ic === "undefined" ? "" : o.ic;

		for (let j = 0; j < item[rootKey].length; j++) {
			let key = rootKey + (j + 1);

			ctx.$set(item, key, item[rootKey][j]);

			if (!headers.some(h => h.value === key)) {
				let text = rootText + (columnCount > 1 ? indexCaption + (j + 1) : "");

				let singularOptions = Object.assign({}, o);
				singularOptions.pp = typeof o.pp === "function" ? o.pp(j + 1) : null;

				headers.push(buildHeader(text, key, singularOptions));
			}
		}
	}

	function buildHeader(text, value, o = {}) {
		return {
			text: text,
			value: value,
			type: o.t ? o.t : "TEXT",
			sortable: typeof o.s === "undefined" ? true : o.s,
			filterable: typeof o.f === "undefined" ? true : o.f,
			editable: typeof o.e === "undefined" ? false : o.e,
			summable: typeof o.su === "undefined" ? false : o.su,
			tooltip: typeof o.tooltip === "undefined" ? false : o.tooltip,
			postProcessor: o.pp,
			headerClass: "header-" + value,
			cellClass: "cell-" + value,
		};
	}

	function isSubstantiveEvaluationBinary(item) {
		return item.isBooleanSubstantiveEvaluation;
	}
</script>

<style>
	.contest-evaluation-summary-view-table {
		display: inline-block;
	}

	.egranty-table.compact-table > div .v-table__overflow {
		overflow: hidden;
	}

	.egranty-table.compact-table > .elevation-1.ranking-list-table .v-table__overflow {
		overflow: auto;
	}

	.egranty-table.compact-table > .elevation-1.ranking-list-table .v-table__overflow th {
		border-right: 1px solid #ddd;
		border-top: 1px solid #ddd;
	}

	.application.mediumFont h2 {
		font-size: 1.3em;
	}

	.contest-evaluation-summary-view-table tbody td {
		border-right: 1px solid #ddd;
	}

	.contest-evaluation-summary-view-table table th {
		border-right: 1px solid #ddd;
		border-top: 1px solid #ddd;
	}

	.contest-evaluation-summary-view-table .compact-table .boolean-column-header span,
	.contest-evaluation-summary-view-table .compact-table .number-column-header span {
		min-width: auto;
	}

	.contest-evaluation-summary-view-table tbody .footer-row td {
		border-right: none;
	}
</style>
